import Vue from "vue";
import Util from "@/utils/Util";
import { initializeOpenAiAds } from "@/utils/OpenAiAds";
import moment from "moment";
import VueTour from 'vue-tour';

initializeOpenAiAds();

Vue.prototype.$moment = moment;

//css import
import "bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
// BootstrapVue add
import { BootstrapVue, IconsPlugin } from "bootstrap-vue";

window.$ = require("jquery");
window.JQuery = require("jquery");

// Router add
import router from "./router";
// Store add
import store from "./store";

//Sidebar add
import VueSidebarMenu from "vue-sidebar-menu";
import "vue-sidebar-menu/dist/vue-sidebar-menu.css";

Vue.use(VueSidebarMenu);

//FontAwesome add
import '@fortawesome/fontawesome-pro/css/all.css';
import '@fortawesome/fontawesome-pro/js/all.js';

import { library } from '@fortawesome/fontawesome-svg-core';
import { fas } from '@fortawesome/pro-solid-svg-icons';
import { fal } from '@fortawesome/pro-light-svg-icons';
import { fad } from '@fortawesome/pro-duotone-svg-icons';
import {FontAwesomeIcon} from "@fortawesome/vue-fontawesome";
library.add(fas, fal, fad);
Vue.component('font-awesome-icon', FontAwesomeIcon);

// Toast add
import CxltToastr from "cxlt-vue2-toastr";
import "cxlt-vue2-toastr/dist/css/cxlt-vue2-toastr.css";

//v-mask add
import VueMask from "v-mask";
Vue.use(VueMask, {
    placeholders: {
        C: /\D/,
    }
});

import VSquircle from "vue-squircle";
Vue.use(VSquircle);

import VuetifulBoard from "vuetiful-board";

Vue.use(VuetifulBoard);
// Axios Add
import Axios from "axios";

// Multi Language Add
import i18n from "./i18n";

Vue.prototype.$cte = function (x, dataArray = []) {
  return Util.translationEngine(x, dataArray);
};

// Axios config

const errorHandler = (error) => {
    if (Axios.isCancel(error)) {
        return new Promise(() => {});
    }

  console.error("error", error);

  if (error.response.status === 401) {
    localStorage.clear();
    localStorage.clear();
    window.location.replace('/login');
  }

  return Promise.reject({ ...error });
};

const successHandler = (response) => {
  return response;
};

Axios.defaults.params = {};

Axios.interceptors.request.use(
  function (config) {
    const jwtToken = localStorage.getItem("token");
    if (config?.headers && jwtToken) {
        config.headers['Authorization'] = jwtToken;
    }

    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

Axios.interceptors.response.use(
  (response) => successHandler(response),
  (error) => errorHandler(error)
);

Vue.prototype.$http = Axios;

Vue.use(BootstrapVue);
Vue.use(IconsPlugin);

Vue.use(CxltToastr, {
  position: "bottom right",
  timeOut: 8000,
});

Vue.config.productionTip = false;

// Store build parameter from URL to sessionStorage if present
// Using sessionStorage instead of localStorage so it doesn't persist between app sessions
const urlParams = new URLSearchParams(window.location.search);
const buildParam = urlParams.get('build');
if (buildParam) {
  sessionStorage.setItem('pwa_build_version', buildParam);
}
Util.storeMarketingAttributionFromUrl();

// voutour add
require('vue-tour/dist/vue-tour.css');
Vue.use(VueTour);

import App from "./App";

export default new Vue({
  i18n,
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
